var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0"},[_c('chart',{attrs:{"id":"bar","options":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }